import { ButtonPresets } from "./buttons";
import { ColorsPresets, MainColor } from "./colors";
import { InputPresets } from "./inputs";

export type ITheme = {
  buttons: {
    [key in ButtonPresets]: {
      backgroundColor: string;
      borderColor: string;
      iconColor: string;
      textColor: string;
    };
  };
  colors: {
    [key in ColorsPresets]: string;
  };
  input: {
    [key in InputPresets]: {
      backgroundColor: string;
      borderColor: string;
      iconColor: string;
      placeholderColor: string;
      textColor: string;
    };
  };
};

export const BuildTheme = (colors: {
  [key in ColorsPresets]: string;
}): ITheme => ({
  buttons: {
    alternative: {
      backgroundColor: colors.white,
      borderColor: colors.white,
      iconColor: colors.black,
      textColor: colors.black,
    },
    contrast: {
      backgroundColor: colors.black,
      borderColor: colors.black,
      iconColor: colors.white,
      textColor: colors.white,
    },
    destructive: {
      backgroundColor: colors.danger,
      borderColor: colors.danger,
      iconColor: colors.white,
      textColor: colors.white,
    },
    primary: {
      backgroundColor: colors.main,
      borderColor: colors.main,
      iconColor: colors.white,
      textColor: colors.white,
    },
    secondary: {
      backgroundColor: colors.mainLight,
      borderColor: colors.mainLight,
      iconColor: colors.main,
      textColor: colors.main,
    },
    selection: {
      backgroundColor: colors.white,
      borderColor: colors.main,
      iconColor: colors.main,
      textColor: colors.main,
    },
    tertiary: {
      backgroundColor: colors.gray3,
      borderColor: colors.gray3,
      iconColor: colors.black,
      textColor: colors.black,
    },
  },
  colors,
  input: {
    primary: {
      backgroundColor: colors.white,
      borderColor: colors.grayLine,
      iconColor: colors.black,
      placeholderColor: colors.gray2,
      textColor: colors.black,
    },
  },
});

export const WhiteTheme = BuildTheme({
  bg1: "#F7F7F7",

  bg2: "#F3F2F7",
  bg3: "#FFFFFF",

  bg4: "#f2f2f2",
  black: "#1d1d1d",
  blue: "#688EE0",
  blueGray: "#D1D4DA",

  danger: "#FE3360",
  danger10: "#FE336010",
  dook: "#7C1E7C",
  dookLight: "#F2E9F2",
  gray1: "#8E8E93",
  gray2: "#B6B6BB",
  gray3: "#F1F1F1",
  gray4: "#8496AF",

  gray5: "#F3F5F7",
  grayLine: "#E9E9E9",
  green: "#25C35A",
  main: MainColor,

  mainLight: `${MainColor}10`,
  secondary: "#622861",
  success: "#14C747",
  successLight: "#E8FAED",

  taker: "#429EFF",
  transparent: "transparent",

  white: "#FFFFFF",
});
